import React from 'react';
import FieldRow from './FieldRow';
import { Checkbox } from '../Inputs';
import { CheckboxFieldProps } from './types';

export default function CheckboxField({ placeholder, label, ...props }) {
    const hasTopLabel = label && placeholder;

    return (
        <FieldRow {...props} label={hasTopLabel ? label : ''}>
            {({
                field: { value, name, onChange, builderInput, ...field },
                form: { setFieldValue, setFieldTouched },
            }) => (
                <Checkbox
                    name={name}
                    checked={!!value}
                    placeholder={hasTopLabel ? placeholder : label}
                    onChange={(e) => {
                        setFieldValue(name, !!e.target.checked);
                        setFieldTouched(name, true, false);
                    }}
                    {...field}
                />
            )}
        </FieldRow>
    );
}

CheckboxField.propTypes = CheckboxFieldProps;
